import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseProductCategory() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      faName: isEmpty(state.faName),
      enName: isEmpty(state.enName),
    };

    setter(errorState);

    if (errorState.faName || errorState.enName) {
      enqueueSnackbar("لطفا اطلاعات دسته محصول را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getCategoryList = (myPC, search, callback, bool) => {
    let newMyPc = myPC;
    if (myPC.sortColumn == "FaName") {
      newMyPc.sortColumn = "Name";
    }
    MyAxios.get(`Admin_ProductCategories?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: newMyPc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };
  const getAllCategoryList = (callback) => {
    MyAxios.get(`Admin_ProductCategories?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getCategoryByID = (id, callback) => {
    MyAxios.get(`Admin_ProductCategories/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
         callback(response.data.resault);
      }
    });
  };

  const updateCategory = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ProductCategories`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("دسته محصول با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addCategory = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ProductCategories`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("دسته محصول با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteCategory = (id, callback) => {
    const data = new FormData();
    data.append("ProductCategoryID", id);
    MyAxios.delete(`Admin_ProductCategories`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("دسته محصول با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    getCategoryList,
    getCategoryByID,
    getAllCategoryList,
    validate,
    updateCategory,
    addCategory,
    deleteCategory,
  };
}
